import { computed, defineComponent, provide, useContext, useCssModule } from '@nuxtjs/composition-api';
import { TEXTS } from '../BrandVoiceAbout';
import { presets } from '~/composables/grid/brandvoice';
import { createGridChunks, getArticlesSize } from '~/composables';
export default defineComponent({
    name: 'BrandVoice',
    props: {
        isDone: {
            type: Boolean,
        },
        tax: {
            required: true,
            type: Object,
        },
        pageOffset: {
            default: 0,
            type: Number,
        },
    },
    setup(props) {
        provide('tax', props.tax);
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const columns = {
            desktop: 2,
            desktopMedium: 2,
            desktopWide: 3,
            mobile: 1,
            mobileMedium: 1,
            mobileWide: 1,
            tablet: 2,
        };
        const context = useContext();
        const viewport = context.$viewport;
        /**
         * Current preset.
         */
        const articlesCards = computed(() => getArticlesSize(viewport.breakpoint, {
            columns,
            presets,
        }));
        /**
         * Grids.
         */
        const grids = computed(() => createGridChunks(props.tax.articles || [], articlesCards.value));
        const currentText = computed(() => TEXTS[props.tax?.url?.replace('brandvoice/', '') || '']);
        function handleGridIntersect(gridKey) {
            gridKey = gridKey + 1 + props.pageOffset;
            history.replaceState(null, '', gridKey > 1 ? `?page=${gridKey}` : context.route.value.fullPath);
        }
        return {
            currentText,
            css,
            columns,
            grids,
            handleGridIntersect,
            presets,
        };
    },
});
